import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { AuthService } from 'src/app/login/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ImportMoneyDoc, User } from 'src/typings';
import { environment } from 'src/environments/environment';
import { normalizeDateRangePayload } from 'src/app/shared/utils/date-filter.util';

@Injectable({
  providedIn: 'root'
})
export class ImportMoneyService {
  user: User | undefined;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService
  ) {
    this.userService.user.subscribe((user) => {
      this.user = user;
    });
  }

  search(payload: {
    id: number;
    date_from: Date;
    date_to: Date;
    user_id: number;
    description: string;
    bank_id: number;
  }) {
    const normalizedPayload = normalizeDateRangePayload(payload);
    return this.http
      .post<
        {
          id: number;
          value: number;
          date: Date;
          passed: boolean;
          description: string;
          user: string;
          bank: string;
          commission: number;
        }[]
      >(`${environment.BACKEND}/doc/import-money/search`, normalizedPayload)
      .pipe(
        map((data) => {
          return data.map((obj) => {
            return (obj = { ...obj, date: new Date(obj.date) });
          });
        })
      );
  }

  getList() {
    return this.http
      .get<
        {
          id: number;
          value: number;
          date: Date;
          passed: boolean;
          description: string;
          user: string;
          bank: string;
        }[]
      >(`${environment.BACKEND}/doc/import-money/list`)
      .pipe(
        map((data) => {
          return data.map((obj) => {
            return (obj = { ...obj, date: new Date(obj.date) });
          });
        })
      );
  }

  getOne(id: number) {
    return this.http.get<ImportMoneyDoc>(`${environment.BACKEND}/doc/import-money/${id}`);
  }

  save(payload: {
    id: number;
    value: number;
    date: Date;
    passed: boolean;
    description: string;
    bank_id: number;
  }) {
    return this.http.put<ImportMoneyDoc>(`${environment.BACKEND}/doc/import-money/save`, payload);
  }

  create(payload: {
    date: Date;
    value: number;
    passed: boolean;
    description: string;
    bank_id: number;
  }) {
    return this.http.post<ImportMoneyDoc>(
      `${environment.BACKEND}/doc/import-money/create`,
      payload
    );
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/doc/import-money/${id}`);
  }
}
